// import React from "react";

// export default function Section2() {
//   const fields = [
//     { id: "name", label: "Name", type: "text" },
//     { id: "contact", label: "Contact", type: "text" },
//     { id: "instagramHandle", label: "Instagram Handle", type: "text" },
//     { id: "facebookPage", label: "Facebook Page (Link)", type: "text" },
//     {
//       id: "instagramFollowers",
//       label: "Number of followers on Instagram",
//       type: "number",
//     },
//     {
//       id: "facebookLikes",
//       label: "Number of Page Likes (Facebook)",
//       type: "number",
//     },
//     {
//       id: "topLocations",
//       label: "Top locations of your followers",
//       type: "text",
//     },
//     { id: "ageRange", label: "Age range of your followers", type: "text" },
//     {
//       id: "staticPostCharges",
//       label: "Charges for a static post",
//       type: "text",
//     },
//     { id: "videoCharges", label: "Charges for a video", type: "text" },
//     { id: "bloggingContent", label: "Type of blogging content", type: "text" },
//     {
//       id: "btlCharges",
//       label: "Charges for BTL/Store raid activity",
//       type: "text",
//     },
//     { id: "storyViews", label: "Average story views", type: "number" },
//     {
//       id: "genderRange",
//       label: "Gender range of your followers",
//       type: "text",
//     },
//   ];

//   return (
//     <div className="Section2 w-full md:px-[15px] mx-auto md:w-[750px] lg:w-[970px] xl:w-[1170px]">
//       <form action="#" method="get" className="flex flex-wrap w-full py-[35px]">
//         {fields.map((field) => (
//           <div
//             key={field.id}
//             className="relative w-full px-[15px] mb-[15px] md:w-1/2"
//           >
//             <input
//               type={field.type}
//               id={field.id}
//               name={field.id}
//               className="peer w-full p-[15px_10px_5px] text-[12px] bg-transparent border-b border-[#555555] outline-none"
//               placeholder=" "
//             />
//             <label
//               htmlFor={field.id}
//               className="absolute text-[#555555] text-[13px] cursor-text top-[18px] left-[15px] transition-all duration-300 ease-in-out peer-placeholder-shown:top-[18px] peer-placeholder-shown:text-[13px] peer-focus:top-[-5px] peer-focus:text-[10px] peer-focus:font-bold"
//             >
//               {field.label}
//             </label>
//           </div>
//         ))}
//         <div className="w-full my-5 text-center btn-container">
//           <a href="#" className="p-[10px_20px] text-center leading-[1.6] font-bold rounded-[3px] xl:w-[25%] bg-[#DA2128] text-[14px] text-white inline-block">Submit</a>
//         </div>
//       </form>

//       <div className="">

//       </div>
//     </div>
//   );
// }



import React, { useState } from "react";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function Section2() {
  const fields = [
    { id: "name", label: "Name", type: "text" },
    { id: "contact", label: "Contact", type: "text" },
    { id: "instagramHandle", label: "Instagram Handle", type: "text" },
    { id: "facebookPage", label: "Facebook Page (Link)", type: "text" },
    { id: "instagramFollowers", label: "Number of followers on Instagram", type: "number" },
    { id: "facebookLikes", label: "Number of Page Likes (Facebook)", type: "number" },
    { id: "topLocations", label: "Top locations of your followers", type: "text" },
    { id: "ageRange", label: "Age range of your followers", type: "text" },
    { id: "staticPostCharges", label: "Charges for a static post", type: "text" },
    { id: "videoCharges", label: "Charges for a video", type: "text" },
    { id: "bloggingContent", label: "Type of blogging content", type: "text" },
    { id: "btlCharges", label: "Charges for BTL/Store raid activity", type: "text" },
    { id: "storyViews", label: "Average story views", type: "number" },
    { id: "genderRange", label: "Gender range of your followers", type: "text" },
  ];

  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Validate required fields
    for (let field of fields) {
      if (!formData[field.id]) {
        toast.error(`Please fill in ${field.label}`);
        return;
      }
    }

    setLoading(true);

    // Send data via FormSubmit without redirecting
    try {
      const response = await fetch("https://formsubmit.co/ajax/info@mean3.com", {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(formData),
      });

      if (response.ok) {
        toast.success("Form submitted successfully!");
        setFormData({}); // Reset form fields
      } else {
        toast.error("Submission failed. Please try again.");
      }
    } catch (error) {
      toast.error("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="Section2 w-full md:px-[15px] mx-auto md:w-[750px] lg:w-[970px] xl:w-[100%] container-1280">
      <form onSubmit={handleSubmit} className="flex flex-wrap w-full py-[35px]">
        {fields.map((field) => (
          <div key={field.id} className="relative w-full px-[15px] my-[10px] md:w-1/2">
            <input
              type={field.type}
              id={field.id}
              name={field.id}
              value={formData[field.id] || ""}
              onChange={handleChange}
              className="peer w-full p-[15px_10px_5px] text-[12px] bg-transparent border-b border-[#555555] outline-none"
              placeholder=" "
            />
            <label
              htmlFor={field.id}
              className="absolute text-[#555555] text-[13px] cursor-text top-[-5px] left-[15px] transition-all duration-300 ease-in-out peer-placeholder-shown:top-[18px] peer-placeholder-shown:text-[13px] 
peer-focus:top-[-5px] peer-focus:text-[13px] 
peer-valid:top-[-5px] peer-valid:text-[13px] peer-focus:font-bold"
            >
              {field.label}
            </label>
          </div>
        ))}

        <div className="w-full my-5 text-center btn-container">
          <button
            type="submit"
            disabled={loading}
            className="p-[10px_20px] text-center leading-[1.6] font-bold rounded-[3px] xl:w-[25%] bg-[#DA2128] text-[14px] text-white inline-block"
          >
            {loading ? "Submitting..." : "Submit"}
          </button>
        </div>
      </form>
      <div class="py-6 pb-16">
        <h2 class="text-xl font-bold mb-4">Terms and Conditions</h2>
        <ul class="list-disc pl-5 space-y-2 text-sm text-gray-800">
          <li>By clicking on this you agree that the information shared is accurate.</li>
          <li>By signing up for this form you agree to be a part of brand campaigns and promotions.</li>
          <li>PR promotions will be shared with you on WhatsApp.</li>
          <li>Mean3 Pvt Ltd will only be acting as the middle-man between you & the brand.</li>
          <li>The payment process will take up to 30-45 days.</li>
        </ul>
      </div>

    </div>
  );
}
